import Swiper from 'swiper/bundle';

const getSwiperA11yMessages = () => {
	const locale = window.Shopify?.locale || document.documentElement.lang || 'uk';
	const isUk = locale === 'uk';

	return {
		enabled: true,
		slideLabelMessage: '',
		paginationBulletMessage: isUk ? 'Перейти до слайду {{index}}' : 'Перейти к слайду {{index}}',
		nextSlideMessage: isUk ? 'Наступний слайд' : 'Следующий слайд',
		prevSlideMessage: isUk ? 'Попередній слайд' : 'Предыдущий слайд',
	};
};

export function related() {
	const sections = document.querySelectorAll('.related');
	sections.forEach((section) => {
		let sliderEl = section.querySelector('.related__grid');
		
		if (sliderEl && !sliderEl.swiper) {
			const paginationEl = section.querySelector('.slider-pagination');
			const prevEl = section.querySelector('.slider-controls__btn--prev');
			const nextEl = section.querySelector('.slider-controls__btn--next');
			const controlsEl = section.querySelector('.related__controls');
			const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
			const toggleControls = (swiper) => {
				if (controlsEl) controlsEl.hidden = swiper.isLocked;
			};

			let slider = new Swiper(sliderEl, {
				loop: slidesCount > 4,
				speed: 500,
				slidesPerView: 4,
				spaceBetween: 24,
				
				pagination: {
					el: paginationEl,
					bulletClass: 'slider-pagination__bullet',
					bulletActiveClass: 'slider-pagination__bullet--active',
					clickable: true
				},
				navigation: {
					prevEl: prevEl,
					nextEl: nextEl
				},
				a11y: getSwiperA11yMessages(),
				on: {
					afterInit: toggleControls,
					lock: toggleControls,
					unlock: toggleControls,
				},

				breakpoints: {
					100: {
						slidesPerView: 1.2,
						spaceBetween: 10
					},
					350: {
						slidesPerView: 1.25,
						spaceBetween: 16
					},
					650: {
						slidesPerView: 2,
						spaceBetween: 16
					},
					900: {
						slidesPerView: 3,
						spaceBetween: 24
					},
					
					1024: {
						slidesPerView: 4,
						spaceBetween: 24
					},
					
				},
			});
		}
	});
}
